import React from 'react';
import { Subheader as SharedSubheader } from 'shared/components';

const Subheader = (props) => {
  return <SharedSubheader data={props.data} />;
};

export default Subheader;
